import { useState } from 'react';

export default function useAction<TAction extends (...args: any[]) => any>(action: TAction) {
  const [inProgress, setInProgress] = useState(false);
  const [error, setError] = useState<unknown>();

  async function execute(...args: Parameters<TAction>) {
    if (inProgress) {
      throw new Error('Action already in progress');
    }

    setInProgress(true);
    setError(undefined);

    try {
      await action(...args);
    } catch (error) {
      setError(error);
    } finally {
      setInProgress(false);
    }
  }

  return {
    execute,
    inProgress,
    error,
  };
}
